<script setup>
  import { computed, onMounted, useTemplateRef, ref, watch } from 'vue'
  import { useIntersectionObserver, useElementBounding, useMediaQuery } from '@vueuse/core'
  import StepListItem from '@/components/InhouseSeminar/StepListItem.vue'

  const isLargeScreen = useMediaQuery('(min-width: 1024px)')
  const wrapper = useTemplateRef('wrapper')
  const stepListItems = ref([])
  const visibleItems = ref([])

  const { top } = useElementBounding(wrapper)

  const signetOffset = ref(40)

  const props = defineProps({
    items: String
  })

  onMounted(() => {
    stepListItems.value = wrapper.value.querySelectorAll('.step-list-item')

    stepListItems.value.forEach((item, index) => {
      if (isLargeScreen.value) {
        useIntersectionObserver(item, ([{ isIntersecting }]) => {
          if (isIntersecting) {
            visibleItems.value.push(item)
          } else {
            visibleItems.value.splice(visibleItems.value.indexOf(item), 1)
          }
        }, {
          threshold: 0.5
        })
      } else {
        item.addEventListener('click', setSignetOffset)
      }
    })
   })

  const items = computed(() => JSON.parse(props.items))

  const setSignetOffset = (event) => {
    if (!event.currentTarget) return
    signetOffset.value = event.currentTarget.offsetTop
  }

  watch(visibleItems.value, () => {
    if (!visibleItems.value.length) return

    if (top.value < 0) {
      const lastItem = stepListItems.value[stepListItems.value.length - 1]
      signetOffset.value = lastItem.offsetTop - 20
      return
    }

    const lastItem = stepListItems.value[visibleItems.value.length - 1]
    signetOffset.value = lastItem.offsetTop - 20
  })
</script>

<template>
  <div
    class="step-list-wrapper relative"
  >
    <div
      class="step-list-line absolute top-0 lg:top-6 right-6 lg:right-auto lg:left-8 w-px h-full bg-border"
    >
      <AppIcon
        class="absolute left-1/2 -translate-x-1/2 transition-transform"
        name="Signet"
        :style="{transform: `translate(-50%, ${signetOffset}px)`}"
      />
    </div>
    <div
      ref="wrapper"
      class="step-list-items pt-10 lg:pt-28 lg:pl-36 flex flex-col"
    >
      <StepListItem
        v-for="(item, index) in items"
        :index="index"
        :item="item"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .step-list-line :deep(svg) {
    @apply ~h-6/12 ~w-6/12;
  }
</style>
